export class DialogModelAddItemsFilter {
    constructor(
      public data: any,
      public currParams: any
    ) {}
}